import { useMediaQuery } from "usehooks-ts"

export const useBreakpoint = (customPx = 0) => {
  const isDesktop = useMediaQuery("(min-width: 1280px)")
  const isSmallDesktop = useMediaQuery("(min-width: 1024px)")
  const isTablet = useMediaQuery("(min-width: 768px)")
  const isLargeMobile = useMediaQuery("(min-width: 640px)")
  const isMediumMobile = useMediaQuery("(min-width: 490px)")
  const isSmallMobile = useMediaQuery("(min-width: 334px)")
  const isReachCustom = useMediaQuery(`(min-width: ${customPx}px)`)

  return {
    isDesktop,
    isSmallDesktop,
    isTablet,
    isLargeMobile,
    isMediumMobile,
    isSmallMobile,
    isReachCustom,
  }
}
